var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M7 0c-.802 0-1.368.527-1.648 1.185H0V16h14V1.185H8.648C8.368.527 7.802 0 7 0zm0 1.185c.35 0 .636.267.636.593v.592h1.91v1.186H4.454V2.37h1.909v-.592c0-.326.286-.593.636-.593zM1.273 2.37h1.909v2.37h7.636V2.37h1.91v12.445H1.272V2.37zM2.545 6.52v1.185h1.273V6.519H2.545zm2.546 0v1.185h6.363V6.519H5.091zm-2.546 2.37v1.185h1.273V8.89H2.545zm2.546 0v1.185h6.363V8.89H5.091zm-2.546 2.37v1.185h1.273V11.26H2.545zm2.546 0v1.185h6.363V11.26H5.091z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.7569caf671c3195bdc2207f1326bebfd.svg";
export { ForwardRef as ReactComponent };